import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6 col-md-12 col-lg-6 mb-25" }
const _hoisted_3 = { class: "card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 stats-box" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center flex-shrink-0 text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-users-four" })
], -1 /* HOISTED */)
const _hoisted_7 = { class: "title ms-15" }
const _hoisted_8 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_9 = { class: "fw-black mb-8 lh-1" }
const _hoisted_10 = { class: "col-sm-6 col-md-12 col-lg-6 mb-25" }
const _hoisted_11 = { class: "card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" }
const _hoisted_12 = { class: "card-body p-15 p-sm-20 p-md-25 stats-box" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center flex-shrink-0 text-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-user-circle-plus" })
], -1 /* HOISTED */)
const _hoisted_15 = { class: "title ms-15" }
const _hoisted_16 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_17 = { class: "fw-black mb-8 lh-1" }
const _hoisted_18 = { class: "col-sm-6 col-md-12 col-lg-6 mb-25" }
const _hoisted_19 = { class: "card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" }
const _hoisted_20 = { class: "card-body p-15 p-sm-20 p-md-25 stats-box" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative rounded-circle text-center flex-shrink-0 text-danger" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-stethoscope" })
], -1 /* HOISTED */)
const _hoisted_23 = { class: "title ms-15" }
const _hoisted_24 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_25 = { class: "fw-black mb-8 lh-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" PATIENTS "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('feature.home.$stats.total_patients')), 1 /* TEXT */),
              _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.stats?.patients_total ?? '-'), 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" CAREGIVERS "),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('feature.home.$stats.total_caregivers')), 1 /* TEXT */),
              _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.stats?.caregivers_total ?? '-'), 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" HCP "),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('feature.home.$stats.total_hcps')), 1 /* TEXT */),
              _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.totalHcps ?? '-'), 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ])
  ]))
}